import React, { Component } from "react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import { getHighlightText } from "./postInfoUtils";
import "./PostPhraseModal.scss";
export default class PostPhraseModal extends Component {
    render() {
        let text = this.props.data.FullPost;
        this.props.data.productAttributes?.forEach((element) => {
            element = element.split(/[+$).]/);

            {
                element.forEach((ele) => {
                    text = getHighlightText(text, `"${ele}"`, true);
                });
            }
        });
        return (
            <Modal noSkipGTranslate={true} className={`add-to-productAttribute-modal `} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>Product Attribute Phrase</Modal.Header>
                <Modal.Content noSkipGTranslate={true} className="add-to-productAttribute-modal-content">
                    <div className="post-content-data" dangerouslySetInnerHTML={{ __html: text }} />
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={() => this.props.hideModal()}>
                        Cancel
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}
